import { render } from "./userLogado.vue?vue&type=template&id=06ce4800"
import script from "./userLogado.vue?vue&type=script&lang=js"
export * from "./userLogado.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__